<template>
  <v-row align="center" justify="space-between">
    <v-col cols="12" md="auto" class="d-flex align-center pl-0">
      <v-btn icon color="primary" class="mr-2" :href="$route('invoices.index')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h2>View {{ invoice.code }}</h2>
    </v-col>
    <v-col cols="12" md="auto">
      <div class="text-caption">
        {{ auditInfo }}
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    auditInfo() {
      const dateFormat = 'DD MMM YYYY, HH:mm'
      let text = `Created at ${this.formatDate(
        this.invoice.created_at,
        dateFormat
      )} by ${this.invoice.created_by_user?.name}`
      if (this.invoice.updated_at) {
        text += `. Last updated at ${this.formatDate(
          this.invoice.updated_at,
          dateFormat
        )} by ${this.invoice.updated_by_user?.name}`
      }
      return text
    },
  },
}
</script>
